import { useState } from 'react';
import { Link } from 'react-router-dom';
import { useAuthStore } from '../store/authStore';
import { notify } from '../utils/notify';
import { HiMail, HiLockClosed, HiEye, HiEyeOff } from 'react-icons/hi';
import { useTranslation } from 'react-i18next';
import GoogleSignInButton from '../components/GoogleSignInButton';


export default function Login() {
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [showPassword, setShowPassword] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const { login } = useAuthStore();
    const { t } = useTranslation();

    const handleSubmit = async (e) => {
        e.preventDefault();
        setIsLoading(true);

        const result = await login(email, password);

        if (result.success) {
            notify.success(t('login.welcome_back'));
        } else {
            notify.error(result.error);
        }

        setIsLoading(false);
    };

    return (
        <div className="space-y-8">
            <div>
                <h2 className="text-2xl font-bold text-white">{t('login.welcome_back')}</h2>
                <p className="text-slate-400 mt-2">{t('login.sign_in_continue')}</p>
            </div>

            <GoogleSignInButton />

            <form onSubmit={handleSubmit} className="space-y-5">
                <div>
                    <label htmlFor="email" className="block text-sm font-medium text-slate-300 mb-1.5">
                        {t('login.email_address')}
                    </label>
                    <div className="relative">
                        <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                            <HiMail className="w-5 h-5 text-slate-500" />
                        </div>
                        <input
                            id="email"
                            type="email"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            className="input pl-10 bg-slate-800 border-slate-700 text-white"
                            placeholder="you@example.com"
                            required
                        />
                    </div>
                </div>

                <div>
                    <label htmlFor="password" className="block text-sm font-medium text-slate-300 mb-1.5">
                        {t('login.password')}
                    </label>
                    <div className="relative">
                        <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                            <HiLockClosed className="w-5 h-5 text-slate-500" />
                        </div>
                        <input
                            id="password"
                            type={showPassword ? 'text' : 'password'}
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            className="input pl-10 pr-10 bg-slate-800 border-slate-700 text-white"
                            placeholder="••••••••"
                            required
                        />
                        <button
                            type="button"
                            onClick={() => setShowPassword(!showPassword)}
                            className="absolute inset-y-0 right-0 pr-3 flex items-center"
                        >
                            {showPassword ? (
                                <HiEyeOff className="w-5 h-5 text-slate-500 hover:text-slate-400" />
                            ) : (
                                <HiEye className="w-5 h-5 text-slate-500 hover:text-slate-400" />
                            )}
                        </button>
                    </div>
                </div>

                {/* Aquí había una casilla «Recordarme» sin `checked`, sin
                    `onChange` y sin `name`: nadie la leía, `handleSubmit` solo
                    manda correo y contraseña, y se podía marcar y desmarcar sin
                    que cambiara nada. Sobrevivió a la limpieza que retiró las
                    tres casillas iguales de Ajustes.

                    No se sustituye por una que funcione porque la sesión **ya**
                    dura siete días sin pedir nada: la casilla no ofrecía una
                    opción, ofrecía la ilusión de una. */}
                <div className="flex items-center justify-end">
                    <Link to="/forgot-password" className="text-sm text-primary-400 hover:text-primary-300">
                        {t('login.forgot_password')}
                    </Link>
                </div>

                <button
                    type="submit"
                    disabled={isLoading}
                    className="btn-primary w-full py-3"
                >
                    {isLoading ? (
                        <span className="flex items-center justify-center gap-2">
                            <svg className="animate-spin w-5 h-5" fill="none" viewBox="0 0 24 24">
                                <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                                <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z"></path>
                            </svg>
                            {t('login.signing_in')}
                        </span>
                    ) : (
                        t('login.sign_in')
                    )}
                </button>
            </form>

            <p className="text-center text-slate-400">
                {t('login.dont_have_account')}{' '}
                <Link to="/register" className="text-primary-400 hover:text-primary-300 font-medium">
                    {t('login.sign_up_free')}
                </Link>
            </p>
        </div>
    );
}
